import { get, isNil, isNull } from 'lodash';
import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { setFeeNotesGpo } from 'containers/PreOpenManagerFeeNote/actions';
import {
  REQUEST_GET_PREOPEN_MANAGER_FEE_NOTE,
  REQUEST_SEARCH_PREOPEN_MANAGER_FEE_NOTE,
} from 'containers/PreOpenManagerFeeNote/constants';
import userToken from 'containers/services/security/access-token-storage';
import currentUserStorage from 'containers/services/security/current-user-storage';

export function* requestPreOpenManagerFeeNotes(action: {
  status: string;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { page, pageSize, status } = action;
  const token = get(userToken.get(), 'token');
  const username = currentUserStorage.get()?.username;
  if (isNull(token)) return;
  const path = `/corporeal/fee-note/gpo-fee-note?status=${status}&page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      username,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesGpo);
}

export function* requestPreOpenManagerFeeNotesSaga() {
  yield takeLeading(
    REQUEST_GET_PREOPEN_MANAGER_FEE_NOTE,
    requestPreOpenManagerFeeNotes,
  );
}

export function* requestSearchPreOpenManagerFeeNotes(action: {
  searchQuery: any;
  type: string;
}): Generator<unknown> {
  const { searchQuery } = action;
  const token = get(userToken.get(), 'token');
  const username = currentUserStorage.get()?.username;
  if (isNull(token)) return;
  const path = !isNil(searchQuery.claimNumber)
    ? `/corporeal/fee-note/gpo-fee-note?claimNumber=${searchQuery.claimNumber}`
    : `/corporeal/fee-note/gpo-fee-note?policyNumber=${searchQuery.policyNumber}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      username,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesGpo);
}

export function* requestSearchPreOpenManagerFeeNotesSaga() {
  yield takeLeading(
    REQUEST_SEARCH_PREOPEN_MANAGER_FEE_NOTE,
    requestSearchPreOpenManagerFeeNotes,
  );
}
export default [
  requestPreOpenManagerFeeNotesSaga,
  requestSearchPreOpenManagerFeeNotesSaga,
];
